"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBusinessMembershipParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Business_1 = require("./Business");
function transformBusinessMembershipParsedResponse(membership) {
    return {
        id: membership.id,
        role: membership.role,
        business: membership.business && (0, Business_1.transformBusinessParsedResponse)(membership.business),
    };
}
exports.transformBusinessMembershipParsedResponse = transformBusinessMembershipParsedResponse;
//# sourceMappingURL=BusinessMembership.js.map